import React, { useState } from "react";
import { TableDateRange } from "../../common/components/TableDateRange";
import { NoRecords } from "../../common/components/NoRecords";
import { LinkArea } from "../../areas/Routes";
import { useQueryWithPagination } from "../../utils/Hooks";
import { AxiosEmployeeAreaAPI } from "../../common/Api";
import { Loader } from "semantic-ui-react";
import { ErrorSegment } from "../../common/components/ErrorSegment";
import { PaginationButtons } from "../../common/components/PaginationButtons";

const EmployeeAreaTable = ({ records, ordering, setOrdering }) => {
  if (records.length === 0) {
    return (
      <NoRecords
        message={"Não existem áreas cadastradas para este funcionário!"}
      />
    );
  }

  const rows = records.map((el) => ({
    id: el.id,
    name: <LinkArea area={el.area} />,
    startDate: el.timespan.lower,
    endDate: el.timespan.upper,
    reviewAccess: el.review_access,
  }));

  return (
    <TableDateRange
      recordName="Área"
      data={rows}
      reviewAccess={true}
      ordering={ordering}
      setOrdering={setOrdering}
      nameColumn="area"
    />
  );
};

export const EmployeeAreaList = ({ employee_id }) => {
  const [ordering, setOrdering] = useState(null);

  const { isPending, data, error, handlePrevious, handleNext } =
    useQueryWithPagination({
      queryKey: ["employee-area-list", employee_id, ordering],
      queryFn: AxiosEmployeeAreaAPI.getForEmployee,
      employee_id: employee_id,
      ordering: ordering,
    });

  if (isPending) return <Loader active />;
  if (error) return <ErrorSegment message={error.message} />;
  if (data) {
    return (
      <>
        <EmployeeAreaTable
          records={data.results}
          ordering={ordering}
          setOrdering={setOrdering}
        />
        <PaginationButtons
          previous={data?.previous}
          next={data?.next}
          onPrevious={handlePrevious}
          onNext={handleNext}
        />
      </>
    );
  }

  return null;
};
